import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";

// Lazy load pages for better performance
const LandingPage = lazy(() => import("@/pages/LandingPage"));
const CVPreviewPage = lazy(() => import("@/pages/CVPreviewPage"));
const GalleryPage = lazy(() => import("@/pages/GalleryPage"));

// Legacy pages (to be updated)
const Research = lazy(() => import("@/pages/Research"));
const Publications = lazy(() => import("@/pages/research/Publications"));
const Collaborations = lazy(() => import("@/pages/research/Collaborations"));

const SignIn = lazy(() => import("@/pages/SignIn"));
const SignUp = lazy(() => import("@/pages/SignUp"));
const AuthCallback = lazy(() => import("@/pages/auth/Callback"));

const Blog = lazy(() => import("@/pages/Blog"));
const BlogPostPage = lazy(() => import("@/pages/BlogPostPage"));
const Downloads = lazy(() => import("@/pages/Downloads"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Refund = lazy(() => import("@/pages/Refund"));
const Contact = lazy(() => import("@/pages/Contact"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

// Loading component
function PageLoader() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-indigo-500 animate-spin mx-auto mb-4" />
        <p className="text-slate-500">Loading...</p>
      </div>
    </div>
  );
}

export function RouteConfig() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="/cv-preview" element={<CVPreviewPage />} />
        <Route path="/gallery" element={<GalleryPage />} />

        {/* Auth Routes */}
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Research & Portfolio */}
        <Route path="/research/*" element={<Research />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/collaborations" element={<Collaborations />} />
        <Route path="/resume" element={<Navigate to="/cv-preview" replace />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/contact" element={<Contact />} />

        {/* Legacy redirects */}
        <Route path="/about-us" element={<Navigate to="/cv-preview" replace />} />
        <Route path="/research/publications" element={<Navigate to="/publications" replace />} />
        <Route path="/solutions" element={<Navigate to="/research" replace />} />
        <Route path="/portfolio" element={<Navigate to="/research" replace />} />

        {/* Removed Projects page — redirect legacy URLs to the consolidated Research page */}
        <Route path="/projects" element={<Navigate to="/research" replace />} />
        <Route path="/research/projects" element={<Navigate to="/research" replace />} />

        {/* Legal */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />

        {/* 404 fallback */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
